export enum PriceType {
  ONE_TIME = 'one_time',
  RECURRING = 'recurring',
}
